import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_STAFFS_URL = `${process.env.PUBLIC_URL}/api/v1/r/staffs`;

export const GET_STAFFS = 'GET_STAFFS';
export const GET_STAFFS_COMPLETED = 'GET_STAFFS_COMPLETED';
export const GET_STAFFS_FAILED = 'GET_STAFFS_FAILED';
export function getStaffs({dispensaryId}) {
  const filter = {
    where: {
      or: [
        {dispensaryId: {eq: dispensaryId}},
        {availableAtAllDispensaries: {eq: true}}
      ]
    },
    order: "name ASC"
  };
  return queryAll(GET_STAFFS_URL, filter, GET_STAFFS, GET_STAFFS_COMPLETED, GET_STAFFS_FAILED);
}

export const SEARCH_STAFF = 'SEARCH_STAFF';
export const SEARCH_STAFF_COMPLETED = 'SEARCH_STAFF_COMPLETED';
export const SEARCH_STAFF_FAILED = 'SEARCH_STAFF_FAILED';
export const searchStaff = querySearch(GET_STAFFS_URL, SEARCH_STAFF, SEARCH_STAFF_COMPLETED, SEARCH_STAFF_FAILED,
  ['name', 'role'], {
    filterMapper: (key, value) => {
      if (key === 'dispensaryId') {
        return {
          or: [
            {dispensaryId: value},
            {availableAtAllDispensaries: {eq: true}}
          ]
        };
      }
      return {[key]: value};
    }
  });

export const GET_STAFF = 'GET_STAFF';
export const GET_STAFF_COMPLETED = 'GET_STAFF_COMPLETED';
export const GET_STAFF_FAILED = 'GET_STAFF_FAILED';
export function getStaff({staffId}) {
  return queryOne(GET_STAFFS_URL, {where: {staffId}}, GET_STAFF, GET_STAFF_COMPLETED, GET_STAFF_COMPLETED);
}

const ADD_STAFF_URL = `${process.env.PUBLIC_URL}/api/v1/staff/addStaff`;
export const ADD_STAFF = 'ADD_STAFF';
export const ADD_STAFF_COMPLETED = 'ADD_STAFF_COMPLETED';
export const ADD_STAFF_FAILED = 'ADD_STAFF_FAILED';
export const addStaff = command(ADD_STAFF_URL, ADD_STAFF, ADD_STAFF_COMPLETED, ADD_STAFF_FAILED);

const FIRE_STAFF_URL = `${process.env.PUBLIC_URL}/api/v1/staff/fireStaff`;
export const FIRE_STAFF = 'FIRE_STAFF';
export const FIRE_STAFF_COMPLETED = 'FIRE_STAFF_COMPLETED';
export const FIRE_STAFF_FAILED = 'FIRE_STAFF_FAILED';
export const fireStaff = command(FIRE_STAFF_URL, FIRE_STAFF, FIRE_STAFF_COMPLETED, FIRE_STAFF_FAILED);

const UPDATE_STAFF_URL = `${process.env.PUBLIC_URL}/api/v1/staff/updateStaff`;
export const UPDATE_STAFF = 'UPDATE_STAFF';
export const UPDATE_STAFF_COMPLETED = 'UPDATE_STAFF_COMPLETED';
export const UPDATE_STAFF_FAILED = 'UPDATE_STAFF_FAILED';
export const updateStaff = command(UPDATE_STAFF_URL, UPDATE_STAFF, UPDATE_STAFF_COMPLETED, UPDATE_STAFF_FAILED);



// WEBPACK FOOTER //
// ./src/Staff/actions.js